var GlobalPresenter = /** @class */ (function () {
    function GlobalPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    //
    GlobalPresenter.prototype.recentClientSearchGet = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.recentClientSearchGet.execute({
                onSuccess: function (data) {
                    _this.actions.recentClientSearchGet(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.recentClientSearchSave = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.recentClientSearchSave.execute({
                onSuccess: function (data) {
                    _this.actions.recentClientSearchSave(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.trxTypeList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.trxTypeList.execute({
                onSuccess: function (data) {
                    _this.actions.trxTypeList(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.updateTypeList = function (response) {
        this.actions.trxTypeList(response);
    };
    GlobalPresenter.prototype.activeTrxTypeList = function (response) {
        this.actions.updateTrxTypeListItem(response);
    };
    GlobalPresenter.prototype.userPopupStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.userPopupStatus.execute({
                onSuccess: function (data) {
                    _this.actions.userPopupStatus(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.userPopupStatusSave = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.userPopupStatusSave.execute({
                onSuccess: function (data) {
                    _this.actions.userPopupStatusSave(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.validateClient = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateClient.execute({
                onSuccess: function (data) {
                    _this.actions.validateClient(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.holdingSummary = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.holdingSummary.execute({
                onSuccess: function (data) {
                    _this.actions.holdingSummary(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.folioDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.folioDetails.execute({
                onSuccess: function (data) {
                    _this.actions.folioDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.holdingQtyDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.holdingQtyDetails.execute({
                onSuccess: function (data) {
                    _this.actions.holdingQtyDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.aggregatedHolding = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aggregatedHolding.execute({
                onSuccess: function (data) {
                    _this.actions.aggregatedHolding(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.uccClientSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.uccClientSearch.execute({
                onSuccess: function (data) {
                    _this.actions.uccClientSearch(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    GlobalPresenter.prototype.uccCodeClientSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.uccCodeClientSearch.execute({
                onSuccess: function (data) {
                    _this.actions.uccCodeClientSearch(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    return GlobalPresenter;
}());
export default GlobalPresenter;
